
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { InviteCodeModelUtil } from '@/model-utils/invite-code-model-util';
import { UserModule } from '@/store/modules/user';
import { EmailSignupActions } from '@/actions/email-signup-actions';
import ErrorWrappedTextInput from '@/components/form-elements/ErrorWrappedTextInput.vue';
import * as fb from '@/firebase';

@Component({ components: {ErrorWrappedTextInput }})
export default class SignupWithCode extends Vue {
  @Prop(String) fromCreateProfileString: string;
  fromCreateProfile = this.fromCreateProfileString == 'true';
  inviteCode: string = '';
  inviteCodeError: string = '';

  created() {
    const inviteCodeParam = this.$route.query.code as string;
    if (inviteCodeParam) {
      this.inviteCode = inviteCodeParam;
      this.submitCode();
    }
  }

  async submitCode() {
    const inviteCode = await InviteCodeModelUtil.findInviteCode(
      this.inviteCode
    );
    if (!inviteCode) {
      this.inviteCodeError = 'That invite code is not valid';
    } else if (!InviteCodeModelUtil.isValid(inviteCode)) {
      this.inviteCodeError = 'That invite code is expired';
    } else {
			console.log('fromCreateProfile', this.fromCreateProfile)
      if (this.fromCreateProfile) {
				this.$router.push(`/create_profile?inviteCode=${inviteCode.code}`)
      } else {
        this.$router.push(`/login?inviteCode=${inviteCode.code}`)
			}
    }
  }

  async submitEmail() {
    await EmailSignupActions.recordEmail(fb.auth.currentUser.email);
    this.$router.push({ name: 'ThanksForEmail' });
  }
}
